export const FETCH_ORGANIZATION = '';
export const ORGANIZATION_URL = '/onedoc_backend/v1/organization';
export const WORKSPACE_URL = '/onedoc_backend/v1/workspaces';
export const FOLDER_URL = '/onedoc_backend/v1/folder';
export const FILE_URL = '/onedoc_backend/v1/file';
export const STARRED_FILE_URL = '/onedoc_backend/v1/files';
export const USER_ORG_MAPPING_URL = '/onedoc_backend/v1/auth/user';
export const BITBUCKET_API_URL = '/onedoc_backend/v1/integration/bitbucket';
export const BITBUCKET_STATE_API_URL = '/onedoc_backend/v1/auth/bitbucket/callback';
export const SCM_FILE_URL = '/onedoc_backend/v1/file/scm';
export const SCM_FOLDER_URL = '/onedoc_backend/v1/folder/scm';
export const USER_ROLE_URL = '/onedoc_backend/v1/roles';
export const USER_PERMISSIONS = '/onedoc_backend/v1/permissions';
export const VALIDATE_USERNAME_URL = '/onedoc_backend/v1/auth/user/details';
export const UPLOAD_OPENAPI = '/onedoc_backend/v1/file/openapi';
export const MEDIA_UPLOAD_URL = '/v1/files/media';
export const workspaceBuildStatus = (id) => `/onedoc_backend/v1/workspaces/build/status/${id}`;
export const workspaceBuilds = (id) => `/onedoc_backend/v1/workspaces/${id}/builds`;
export const WORKSPACE_BUILD_INIT_URL = `/onedoc_backend/v1/workspaces/build`;
export const getTrashFilesUrl = (id) => `/onedoc_backend/v1/workspaces/${id}/trash`;
export const USER_LOGOUT = '/onedoc_backend/v1/auth/logout';
export const TEMPLATE = '/onedoc_backend/v1/templates';
export const PROFILE_URL = 'onedoc_backend/v1/profile';
export const GET_PROFILE = '/onedoc_backend/v1/get_profile';

// auth apis
export const GOOGLE_SIGNIN_URL = 'onedoc_backend/v1/auth/google_sign_in';
export const PHONE_CREATE_TOKEN = '/api/v6/create_token';
export const PHONE_VERIFY_TOKEN = '/api/v6/verify_token';

// get user suggestions
export const USER_SUGGESTIONS = '/onedoc_backend/v1/auth/user/suggestions';
export const FILE_COMMENTS = '/onedoc_backend/v1/interaction';
export const NOTIFICATION_URL = '/onedoc_backend/v1/notifications';
export const PERMISSION_API_URL = 'onedoc_backend/v1/permissions';

export const SEARCH_API_URL = '/onedoc_backend/v1/search';
export const ANNOUNCEMENT_API_URL = '/onedoc_backend/v1/announcements/all';
export const CREATE_ANNOUNCEMENT_API_URL = '/onedoc_backend/v1/announcements';
export const NEWSLETTER_API_URL = '/onedoc_backend/v1/newsletter';
export const TAGS_API_URL = 'onedoc_backend/v1/tag';

// ai endpoints
export const START_CHAT_API = ({ query, id, isWorkspace, conversationId }) => {
  return `/ai/embeddings/session/chat?query=${query}${id ? `&${isWorkspace ? 'workspace_id' : 'file_id'}=${id}` : ''}${conversationId ? '&thread_id=' + conversationId : ''}`;
};

export const FLOCK_CHANNELS = '/onedoc_backend/v1/webhooks';
export const Announcement = '/onedoc_backend/v1/announcement';
export const SummaryConfig = '/onedoc_backend/v1/prompt-config';

export const USER_TOP_REACTIONS = '/onedoc_backend/v1/user/top-reactions';
export const USER_RECENT_ACTIVITY = '/onedoc_backend/v1/recent';
export const WORKSPACE_API_URL = '/onedoc_backend/v1/workspace';

export const ONEDOC_SITE_API_URL = '/onedoc_backend/v1';
